import ca_fallback from "./ca/fallback.json";
import oc_fallback from "./oc/fallback.json";
import gl_fallback from "./gl/fallback.json";
import eu_fallback from "./eu/fallback.json";
import en_fallback from "./en/fallback.json";
import es_fallback from "./es/fallback.json";


export default {
  ca: { fallback: ca_fallback },
  oc: { fallback: oc_fallback },
  gl: { fallback: gl_fallback },
  eu: { fallback: eu_fallback },
  en: { fallback: en_fallback },
  es: { fallback: es_fallback }
}
